import React, { useState, useEffect } from "react";
import { Box, Typography, Card, CardContent, Grid, FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import BusinessIcon from "@mui/icons-material/Business";
import PersonIcon from "@mui/icons-material/Person";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import PercentIcon from "@mui/icons-material/Percent";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import AssessmentIcon from "@mui/icons-material/Assessment";
import BoxWrapper from "../../../../../components/ui/boxWrapper";
import axios from "../../../../../axios-order";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useHistory } from "react-router-dom";
import { IconButton, Tooltip } from '@mui/material';
import Chip from '@mui/material/Chip';
import RefreshIcon from '@material-ui/icons/Refresh';
import ComplianceMonitor from "../../../../Compliance_Monitor/ComplianceMonitor";

const ComplianceData = {
    tax: [
        { icon: <PercentIcon color="primary" />, title: "GSTR", subtitle: "Goods & Services Tax" },
        { icon: <CreditCardIcon color="primary" />, title: "TDS", subtitle: "Tax Deducted at Source" },
        { icon: <MonetizationOnIcon color="primary" />, title: "TCS", subtitle: "Tax Collected at Source" },
    ],

    hr: [
        { icon: <AccountBalanceIcon color="success" />, title: "PF", subtitle: "Provident Fund" },
        { icon: <AssessmentIcon color="success" />, title: "ESI", subtitle: "Employee State Insurance" },
        { icon: <AccountBalanceWalletIcon color="success" />, title: "PT", subtitle: "Professional Tax" },
    ],
};

const cardStyles = {
    height: 100,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    margin: "auto",
    borderRadius: 2,
    boxShadow: 1,
    cursor: "pointer",
    "&:hover": { boxShadow: 4, transform: "scale(1.05)", transition: "0.2s" },
};

const contentStyles = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-between",
    textAlign: "center",
    height: "100%",
    padding: "12px 0",
    boxSizing: "border-box",
};

const ComplianceMonitorGroup = () => {
    const [errorMessage, setErrorMessage] = useState(null);
    const [data, setData] = useState(null);
    const [showPenaltyView, setShowPenaltyView] = useState(false);
    const [activeCard, setActiveCard] = useState("GSTR");
    const [loaderInRefresh, setLoaderInRefresh] = useState(false);
    const [isPenaltyButtonDisabled, setIsPenaltyButtonDisabled] = useState(false);
    const [penaltyErrorMessage, setPenaltyErrorMessage] = useState(null);
    const [availableGSTReturns, setAvailableGSTReturns] = useState([]);
    const [penaltyData, setPenaltyData] = useState(null);
    const [penaltyLoading, setPenaltyLoading] = useState(false);
    const [warningMessage, setWarningMessage] = useState(null);
    const [skippedEntities, setSkippedEntities] = useState([]);
    const [showPenaltyTable, setShowPenaltyTable] = useState(false);
    const [editableTaxPaid, setEditableTaxPaid] = useState({});
    const [calculatedValues, setCalculatedValues] = useState({});
    const [selectedPenaltyCard, setSelectedPenaltyCard] = useState(null);
    const [loaderInRunReport, setLoaderInRunReport] = useState(false);
    const [lastReportRunDatetime, setLastReportRunDatetime] = useState('');
    const [selectedEntity, setSelectedEntity] = useState(null);

    let history = useHistory();
    const handleBack = () => {
        history.push('/home');
    };
    const [formValues, setFormValues] = useState({
        returnPeriod: "Last 3 Months",
    });

    const handleCardClick = (title) => {
        setActiveCard(title);
        console.log('Card clicked:', title);
    };



    const handleTaxPaidChange = (index, value) => {
        if (penaltyData && penaltyData.penalty_details[index]) {
            const delayPeriod = parseInt(penaltyData.penalty_details[index].delay_period) || 0
            if (delayPeriod === 0) {
                return;
            }
        }
        const numValue = value === '' ? 0 : Math.max(0, parseFloat(value) || 0);
        setEditableTaxPaid(prev => ({
            ...prev,
            [index]: value
        }));
        if (penaltyData && penaltyData.penalty_details[index]) {
            const row = penaltyData.penalty_details[index];
            const taxPaid = numValue;
            const delayPeriod = parseInt(row.delay_period) || 0;
            const penaltyPerDay = parseFloat(row.penalty_for_each_day_of_default) || 0;

            // Interest Amount = taxpaid * 18% * no.of days delayed / 365
            const interestAmount = (taxPaid * 0.18 * delayPeriod) / 365;

            // Penalty Exposure = Interest Amount + Penalty for each day of default
            const penaltyExposure = interestAmount + (penaltyPerDay * delayPeriod);

            setCalculatedValues(prev => ({
                ...prev,
                [index]: {
                    interestAmount: interestAmount.toFixed(2),
                    penaltyExposure: penaltyExposure.toFixed(2)
                }
            }));
        }
    };


    const handleRunReport = () => {
        const user_id = localStorage.getItem("user_id");
        const selectedPeriod = returnPeriods.find(p => p.label === formValues.returnPeriod);
        const num_months = idToMonths[selectedPeriod.id];

        setLoaderInRunReport(true);
        const requestBody = {};
        requestBody.user_id = parseInt(user_id);
        requestBody.num_months = num_months;

        axios
            .post('/fetch_status_details', {
                requestBody
            })
            .then(response => {
                console.log("Run Report Response:", response.data);

                // Only use the data the backend sent
                if (response.data.results && response.data.results.length > 0) {
                    const transformedData = transformFilingData(response.data.results);
                    setData(transformedData);
                    setErrorMessage(null);
                    setIsPenaltyButtonDisabled(false);

                    if (response.data.warning && response.data.skipped_entities) {
                        setWarningMessage(response.data.warning);
                        setSkippedEntities(response.data.skipped_entities);
                    } else {
                        setWarningMessage(null);
                        setSkippedEntities([]);
                    }

                    // Store all entity IDs
                    const entityIds = response.data.results
                        .filter(entity => entity.id)
                        .map(entity => entity.id);

                    if (entityIds.length > 0) {
                        localStorage.setItem("entity_ids", JSON.stringify(entityIds));
                        localStorage.setItem("compliance_summary_id", entityIds[0]);
                    }
                } else {
                    setErrorMessage({
                        text: response.data.message,
                        isSuccess: response.data.status === true
                    });
                    setData([]);
                    setIsPenaltyButtonDisabled(true);
                }
            })
            .catch(error => {
                console.error('Error running report:', error);
                setErrorMessage(error.response?.data?.message || null);
                setData([]);
                setIsPenaltyButtonDisabled(true);
            })
            .finally(() => {
                setLoaderInRunReport(false);
            });
    };


    useEffect(() => {
        if (penaltyData && penaltyData.file_type === 'GSTR3B') {
            const initialCalculations = {};
            penaltyData.penalty_details.forEach((row, index) => {
                const delayPeriod = parseInt(row.delay_period) || 0;

                // Only calculate if delay period is greater than 0
                if (delayPeriod > 0) {
                    const taxPaid = parseFloat(row.tax_paid) || 0;
                    const penaltyPerDay = parseFloat(row.penalty_for_each_day_of_default) || 0;

                    const interestAmount = (taxPaid * 0.18 * delayPeriod) / 365;
                    const penaltyExposure = interestAmount + (penaltyPerDay * delayPeriod);
                    initialCalculations[index] = {
                        interestAmount: interestAmount.toFixed(2),
                        penaltyExposure: penaltyExposure.toFixed(2)
                    };
                }
            });
            setCalculatedValues(initialCalculations);
        }
    }, [penaltyData]);

    const returnPeriods = [
        { id: 1, label: "Last 3 Months" },
        { id: 2, label: "Last 6 Months" },
        { id: 3, label: "Last 12 Months" }
    ];

    const idToMonths = {
        1: 3,
        2: 6,
        3: 12
    };


    const isYearlyFiling = (returnType) => {
        return returnType === "GSTR9" || returnType === "GSTR9C";
    };

    const extractAvailableGSTReturns = (filingData) => {
        if (!filingData) return [];
        return Object.keys(filingData).filter(key => Array.isArray(filingData[key]));
    };

    const transformFilingData = (results) => {
        if (!results || results.length === 0) return [];
        if (results[0]?.filing_data) {
            const availableReturns = extractAvailableGSTReturns(results[0].filing_data);
            console.log("360 ------->", availableReturns);

            setAvailableGSTReturns(availableReturns);
            localStorage.setItem('available_gst_returns', JSON.stringify(availableReturns));
        }

        return results.map(entity => {
            const filingData = entity.filing_data || {};
            const filingSummary = [];

            // Transform each return type (GSTR1, GSTR3B, etc.)
            Object.keys(filingData).forEach(returnType => {
                const periods = filingData[returnType] || [];
                const summaryRow = { Return_Type: returnType };

                periods.forEach(period => {
                    const monthKey = period.return_period; // e.g., "Apr-23"
                    summaryRow[monthKey] = {
                        date: period.date_of_filing,
                        isDelayed: period.is_delay_file === "True"
                    };
                });

                filingSummary.push(summaryRow);
            });

            return {
                ...entity,
                filing_status_details: {
                    Filing_Summary: filingSummary
                }
            };
        });
    };

    

    const filingSummary = data?.[0]?.filing_status_details?.Filing_Summary || [];
    const filteredFilingSummary = filingSummary.filter(filing =>
        activeCard === "GSTR" ? filing.Return_Type.includes("GSTR") : filing.Return_Type.includes(activeCard)
    ) || [];

    const yearlyFilings = filteredFilingSummary.filter(filing => isYearlyFiling(filing.Return_Type));
    const monthlyFilings = filteredFilingSummary.filter(filing => !isYearlyFiling(filing.Return_Type));

    let maxMonthsCount = 0;
    monthlyFilings.forEach(filing => {
        const monthCount = Object.keys(filing).filter(key => key !== "Return_Type").length;
        if (monthCount > maxMonthsCount) {
            maxMonthsCount = monthCount;
        }
    });

    const handlePenaltyCalculation = (fileType, summary_id, business_entity_id) => {
        //const business_entity_id = localStorage.getItem("business_entity_id");
        //const summary_id = localStorage.getItem("compliance_summary_id");

        if (!business_entity_id || !summary_id) {
            console.error("Missing required IDs");
            return;
        }
        setSelectedPenaltyCard(fileType);
        setPenaltyLoading(true);
        setShowPenaltyTable(false);
        setPenaltyData(null);
        setPenaltyErrorMessage(null);
        axios
            .post('/compliance_penalty_calculation', {
                business_entity_id,
                summary_id,
                file_type: fileType
            })
            .then(response => {
                console.log("Penalty Calculation Response:", response.data);
                if (response.data.penalty_details && response.data.penalty_details.length > 0) {
                    setPenaltyData(response.data);
                    setPenaltyErrorMessage(null);
                    setShowPenaltyTable(true);
                } else {
                    // No penalty details means error/message case
                    setPenaltyErrorMessage(response.data.message || 'No penalty data available');
                    setPenaltyData({ file_type: fileType }); // Store file_type for title
                    setShowPenaltyTable(true);
                }
            })
            .catch(error => {
                console.error('Error calculating penalty:', error);
                setPenaltyErrorMessage(error.response?.data?.message || 'Error calculating penalty');
                setPenaltyData({ file_type: fileType });
                setShowPenaltyTable(true);
            })
            .finally(() => {
                setPenaltyLoading(false);
                setSelectedPenaltyCard(null);
            });
    };

    const numRows = Math.ceil(maxMonthsCount / 3);

    const leftColumnsCount = 1 + yearlyFilings.length;

    return (
        <ComplianceMonitor/>
    );
};

export default ComplianceMonitorGroup;